// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3ps71","selected":"Chip_selected__2jn46"};